import { useDebounce as useObservableDebounce } from './useObservableDebounce';

export const useDebounce = <T>(value: T, timeoutMs: number) => {
  const { value: state } = useObservableDebounce(value, timeoutMs);
  return state;
};

export default useDebounce;
